export default {
    'event-calendar-event-type-label-exhibition': 'Kiállítás',
    'event-calendar-event-type-label-event': 'Rendezvény',

    'event-calendar-event-card-free_slot':' szabad hely van',
    'event-calendar-event-card-no_free':'Nincs szabad hely',
};
